/**
 * Created by Ivan on 24.05.2025
 */

const BombTutorial = function () {
    return new TutorialScenario(BombTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createPlayCardStep(BombTutorial.CONFIG)
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(BombTutorial.NAME);
            Game.currentGame.hand.setCards(BombTutorial.CONFIG.handValues);

            cleverapps.focusManager.setEventNodes([cleverapps.Scenes.GetRunningScene()]);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(BombTutorial.NAME)
    });
};

BombTutorial.NAME = "bomb";
BombTutorial.CONFIG = {
    handValues: ["9"],
    force: "BombTutorialMessage",
    filter: ["t"]
};
